import AuthForm from './authForm';
import ChangePassword from './changePassForm';
import ChangeDefault from './changeDefaultForm'
import UserForm from './userForm';
import ADUser from './ADUserForm';
import ADFilter from './ADFilterForm';
import UserEditForm from './userEditForm';
import LDAPData from './LDAPDataList';




export default {
    AuthForm, ChangePassword, UserForm, ADUser, ADFilter, UserEditForm, LDAPData, ChangeDefault
}


// WEBPACK FOOTER //
// ./src/pages/General/Users/forms/index.js